//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ReagendamentoPage } from './ReagendamentoPage';

export default class ReagendamentoIndexPage extends React.Component<{}> {
  render() {
    return (
      <Switch>
        <Route path="/reagendamento/" component={ReagendamentoPage} exact />
      </Switch>
    );
  }
}
